import React, { useEffect } from 'react';
import { WithWizard } from 'react-albus-react18';

import CaseContent from './CaseContent';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import useMixpanel from '../../hooks/useMixpanel';
import PageContent from '../../components/PageContent/PageContent';

const Case = ({ id }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));
        dispatch(setIsShowButtonNot(false));
    }, []);

    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const { trackP1Event } = useMixpanel();

    const eventNames = ['onboarding_video_usecase', 'onboarding_static_usecase', 'onboarding_ad_usecase', 'onboarding_summary_proof'];
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            trackP1Event(eventNames[id], {})
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);


    return (
        <div className="page" >
            <PageContent>
                <div className="page-content">
                    <CaseContent id={id} />
                </div>
            </PageContent>
        </div>
    );
}

export default Case;
